import React from 'react';

const Header = () => {
  return (
    <div className="w-screen h-16 sticky bg-slate-400 sm:h-[80px] sm:fixed z-50" />
  );
};

export default Header;
